import { useCallback } from "react";

import { useTranslate } from "../../../i18n/useTranslationModules";
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import { SessionTypesEnum } from "../../../types/working-model";

interface ISessionTypeProps {
	sessionType: SessionTypesEnum;
	casing?: 'upper' | 'lower';
}

const SessionType: React.FC<ISessionTypeProps> = ({ sessionType, casing }) => {

	const { t } = useTranslate('homepage');

	const translationUpdates = useTypedSelector(event => event.LiveEventReducer.translationUpdates);

	const typeText = useCallback((sessionType: string) => {
		switch (sessionType) {
			case SessionTypesEnum.onDemand: {
				return t("homepage:On Demand", "");
			}
			case SessionTypesEnum.broadcast: {
				return t("homepage:Broadcast", "");
			}
			case SessionTypesEnum.breakoutRooms: {
				return t("homepage:Breakout Rooms", "");
			}
			case SessionTypesEnum.fireside: {
				return t("homepage:Fireside", "");
			}
			default: {
				return "";
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [t, translationUpdates]);

	if (casing === 'lower') {
		return <>{typeText(sessionType).toLowerCase()}</>;
	}
	if (casing === 'upper') {
		return <>{typeText(sessionType).toUpperCase()}</>;
	}
	return <>{typeText(sessionType)}</>;
};

export default SessionType;
